export default "__VITE_ASSET__UFKx_j9E__"